import {MessageType, WireRequest, WireResponse} from "../pages/Admin/WireServiceMessage/ServiceMessageForm/types"
import {createResource} from "./common"

export async function sendWireMessage(accessToken: string, data: WireRequest, incoming: boolean, type: MessageType) {
	const url = `wire-service-messages/${incoming ? "incoming-wire/" : ""}${type}`
	return await createResource<WireResponse>(url, accessToken, data)
}
